<div [formGroup]="occurrenceForm" class="description-container">
	  <h2 class="title">descrição</h2>
	  <mat-form-field>
      <textarea
        id="occurrence-description"
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        formControlName="description"
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="5"
        maxlength="2000">
      </textarea>
      <mat-hint align="end">{{ 2000 - occurrenceForm.controls['description'].value?.length }} caracteres restantes.</mat-hint>
	  </mat-form-field>
</div>